
import Link from 'next/link';
import { Icon } from '@/components/site/ui';
import { cn } from '@/lib/utils';

export interface CheckListItem {
  id: string;
  label: string;
  done: boolean;
  /** Where to fix a missing item; only an undone item renders it as a link. */
  href?: string;
}

/** A vertical list of yes/no items, each ticking green when done. The one markup for
 *  "what is still missing" lists: the password rules and the profile completion both
 *  render through it. `aria-live` is for lists that tick while the user types. */
export function CheckList({
  items,
  live = false,
  size = 'sm',
  className,
}: {
  items: readonly CheckListItem[];
  live?: boolean;
  /** md: a card's own checklist (Início's "Comece por aqui"), body-size rows. */
  size?: 'sm' | 'md';
  className?: string;
}) {
  const md = size === 'md';
  return (
    <ul className={cn('flex flex-col', md ? 'gap-3' : 'gap-1', className)} aria-live={live ? 'polite' : undefined}>
      {items.map((item) => (
        <li
          key={item.id}
          className={cn(
            'flex items-center',
            md ? 'gap-2.5 text-sm' : 'gap-1.5 text-xs',
            item.done ? 'text-success-soft-foreground' : 'text-muted-foreground',
          )}
        >
          <Icon name={item.done ? 'checkmark-circle-02' : 'circle'} size={md ? 18 : 14} className="shrink-0" />
          {item.href && !item.done ? (
            <Link
              href={item.href}
              className={cn(
                'underline underline-offset-2 hover:text-foreground',
                md && 'font-medium text-foreground decoration-dotted decoration-2 underline-offset-4 hover:text-medlux',
              )}
            >
              {item.label}
            </Link>
          ) : (
            item.label
          )}
        </li>
      ))}
    </ul>
  );
}
